module.exports = __webpack_public_path__ + "static/BiancoSansNew-cfc1ae85b875c7de558db44f5e06bc93.woff2";